
import { CustomFieldsApi } from '../../constants/ApiConstants';
import { HTTPMethod, callApi as customFieldsRequest } from '../../services/HttpService/HttpService';
import { regExPattern } from '../constants';
import { CustomFieldType, DefaultCustomFields, deliveryOrderType, FileUploadComponent } from '../enums';

export const handleGetIntialCustomFields = async (locationId, companyId = 0, entityType = null, entityId = null) => {
  const customFieldArray = [];
  const requestBody = {
    "branch_id": locationId,
    "company_id": companyId,
    "entity_type": entityType,
    "entity_id": entityId
  };
  const customFieldsResponse = await customFieldsRequest(HTTPMethod.Post, CustomFieldsApi.getData, requestBody);
  if (customFieldsResponse && customFieldsResponse.status_code == 200 && customFieldsResponse.data?.custom_fields?.length > 0) {
    customFieldsResponse.data?.custom_fields.forEach((item) => {
      customFieldArray.push(item);
    });
  }
  return customFieldArray;
};

export const handleOrderCustomFields = async (setOrderCustomFields, locationId, companyId = 0, entityId = null) => {
  const customFieldResponse = await handleGetIntialCustomFields(locationId, companyId, FileUploadComponent.Order, entityId);
  setOrderCustomFields(customFieldResponse);
};

export const handlePatientCustomFields = async (setPatientCustomFields, setEmrField, locationId, companyId = 0, entityId = null) => {
  const customFieldResponse = await handleGetIntialCustomFields(locationId, companyId, FileUploadComponent.Patient, entityId);
  setPatientCustomFields(customFieldResponse);
  setEmrField(customFieldResponse.find(field=>field.column === DefaultCustomFields.emrNumber));
};

export const handleOrderCustomFieldsCheck = async(orderCustomFieldObj, orderCustomFields, orderType, setOrderCustomData, handlePatientSuccess,setIsDifferentState) => {
  if (orderType === deliveryOrderType.Supplies || !orderCustomFields?.length) {
    handlePatientSuccess();
  } else if (orderCustomFields?.length > 0) {
     if(orderType === deliveryOrderType.Quote) {
      handleOrderCustomFieldSave(orderCustomFieldObj, orderCustomFields, setOrderCustomData, true);
      handlePatientSuccess();
     } else {
       await orderCustomFieldObj.trigger(null,{shouldFocus:true})
       if(orderCustomFieldObj?.formState?.isValid) {
         handleOrderCustomFieldSave(orderCustomFieldObj, orderCustomFields, setOrderCustomData);
         handlePatientSuccess();
       } else {
         handleRadioButtonError(orderCustomFields, orderCustomFieldObj?.watch);
         setIsDifferentState(false);
       }
     }
  } 
};

export const handleOrderCustomFieldSave = async (orderCustomFieldObj, orderCustomFields, setOrderCustomData, isQuoteOrder = false) => {
  const handleCustomFieldSuccess = (data) => {
    const customFields = {};
    if (orderCustomFields?.length > 0) {
      orderCustomFields.forEach(field => {
        if (Object.values(CustomFieldType).includes(field.data_type)) {
          switch (field.data_type) {
            case CustomFieldType.date: {
              customFields[field.custom_field_id] = data[field.column] ? data[field.column].format().split("T")[0] : null;
            }
              break;
            case CustomFieldType.switch: 
            case CustomFieldType.lookup: {
              customFields[field.custom_field_id] = data[field.column] ? data[field.column] : null;
            }
              break;
            default: {
              customFields[field.custom_field_id] = data[field.column];
            }
              break;
          }
        }
      });
    }
    setOrderCustomData(customFields);
  };
  if(isQuoteOrder) {
     handleCustomFieldSuccess(orderCustomFieldObj.watch());
  } else {
    await orderCustomFieldObj.handleSubmit(handleCustomFieldSuccess)();
  }
};
const handleCustomFieldTypeSet = (data, type, fieldId, column, customFields) => {
  switch (type) {
    case CustomFieldType.date: {
      customFields[fieldId] = data[column] ? data[column].format().split("T")[0] : null;
    }
      break;
    case CustomFieldType.switch:
    case CustomFieldType.lookup: {
      customFields[fieldId] = data[column] ? data[column] : null;
    }
      break;
    default: {
      customFields[fieldId] = data[column];
    }
      break;
  }
};
const handleCustomFieldDefaultTypeSet = (fieldId, column, data, height, customFields, emrNumber, isEmrIntegrated) => {
  switch(column) {
    case DefaultCustomFields.height: {
      customFields[fieldId] = height ? height.trim() : "";
    }
    break;
    case DefaultCustomFields.weight: {
      customFields[fieldId] = data.patientWeight ? data.patientWeight.trim().replace(regExPattern.removeLeadingZeros, '') : "";
    }
    break;
    case DefaultCustomFields.dateOfBirth: {
      if(!isEmrIntegrated) {
        customFields[fieldId] = data.patientDob ? data.patientDob.format().split("T")[0] : null;
      }
    }
    break;
    case DefaultCustomFields.emrNumber: {
      if(!isEmrIntegrated) {
        customFields[fieldId] = emrNumber ?? ""
      }
    }
    break;
  }
};
export const handleGetCustomFields = (data, customFieldArray, height, emrNumber, isEmrIntegrated=false) => {
  const customFields = {};
  if (customFieldArray?.length > 0) {
    customFieldArray.forEach(field => {
      if(Object.values(CustomFieldType).includes(field.data_type)) {
        if (Object.values(DefaultCustomFields).includes(field.column)) {
          handleCustomFieldDefaultTypeSet(field.custom_field_id, field.column, data, height, customFields, emrNumber, isEmrIntegrated);
        } else {
          handleCustomFieldTypeSet(data, field.data_type, field.custom_field_id, field.column, customFields);
        }
      }
    });
  }
  return customFields;
};
export const handleCustomFieldMissingCheck = (customFieldArray, demographicForm, missingDemographicsArray, mrn, isEmrIntegrated) => {
  if (customFieldArray.length === 0) {
    return false;
  }
  return missingDemographicsArray.some(field => {
    const customField = customFieldArray.find(item => item.display_name === field);
    if(customField.column == DefaultCustomFields.emrNumber && !isEmrIntegrated && customField?.is_required && !mrn){
      return !demographicForm.watch("mrn");
    }
    if (customField?.is_required && !customField.value) {
      return !demographicForm.watch(customField.column);
    }
    return false;
  });
};

export const handleGetMissingCustomFields = (customFields, isEmrIntegrated) => {
  if (customFields.length === 0) {
    return [];
  }
  return customFields.filter(field =>  (!Object.values(DefaultCustomFields).includes(field.column) || field.column == DefaultCustomFields.emrNumber && !isEmrIntegrated) && Object.values(CustomFieldType).includes(field.data_type)).reduce((previousValue, currentValue) => {
    if ( currentValue.is_required && !currentValue.value) {
      previousValue.push(currentValue.display_name);
    }
    return previousValue;
  }, []);
};

export const handleCheckCustomFieldChange = (demographicObj, patientCustomFields) => {
  if (patientCustomFields.length === 0) {
    return false;
  }
  return patientCustomFields.filter(field => !Object.values(DefaultCustomFields).includes(field.column)).some(field => {
    if (field.data_type == CustomFieldType.date) {
      return demographicObj.watch(field.column)?.format()?.split("T")?.[0] !== field.value;
    } 
     else {
      return demographicObj.watch(field.column) !== field.value;
    }
  });
};

export const handleAddOrderCustomFields = (orderCustomFields) => {
  if (orderCustomFields) {
    return orderCustomFields;
  }
};

export const handleEditOrderCustomFields = async (orderCustomFields, branchId, orderId) => {
  const requestBody = {
    "entity_id": orderId,
    "entity_type": FileUploadComponent.Order,
    "branch_id": branchId,
    "custom_field_data": orderCustomFields
  };
  await customFieldsRequest(HTTPMethod.Post, CustomFieldsApi.edit, requestBody);
};

export const handleCustomFieldError = (customFieldLength, customFieldObj) => {
  if (customFieldLength) {
    customFieldObj.trigger(null, { shouldFocus: false });
  }
};
const handleAddPatient = (patientSave, handleAddPatientApi) => {
  if (patientSave) {
    handleAddPatientApi();
  }
};
export const handleAddNewCustomField = async (patientSave, orderCustomFields, handleAddPatientApi, orderCustomFieldObj, setOrderCustomData, orderType) => {
  if (orderType !== deliveryOrderType.Supplies && orderCustomFields?.length > 0) {
    if (orderType === deliveryOrderType.Quote) {
      handleOrderCustomFieldSave(orderCustomFieldObj, orderCustomFields, setOrderCustomData, true);
      handleAddPatient(patientSave, handleAddPatientApi);
    } else {
      await orderCustomFieldObj.trigger(null, { shouldFocus: true });
      if (orderCustomFieldObj?.formState?.isValid) {
        handleOrderCustomFieldSave(orderCustomFieldObj, orderCustomFields, setOrderCustomData);
        handleAddPatient(patientSave, handleAddPatientApi);
      } else {
        handleRadioButtonError(orderCustomFields, orderCustomFieldObj?.watch);
      }
    }
  } else {
    handleAddPatient(patientSave, handleAddPatientApi);
  }
};

export const handleRadioButtonError = (customFields, watch) => {
  let isValid = true;
  const fields = customFields.filter(item=>item.data_type === CustomFieldType.switch);
  if(fields.length > 0) {
    fields.forEach((field)=>{
      if(!watch(field.column)) {
        isValid = false;
        document.getElementById(field.column)?.focus();
      }
    })
  }
  return isValid;
}
